module.exports = __webpack_public_path__ + "static/media/successIcon.9f0fe8b0.svg";